import { render, staticRenderFns } from "./MainFrame.vue?vue&type=template&id=41d276aa&scoped=true&"
import script from "./MainFrame.vue?vue&type=script&lang=js&"
export * from "./MainFrame.vue?vue&type=script&lang=js&"
import style0 from "./MainFrame.vue?vue&type=style&index=0&id=41d276aa&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41d276aa",
  null
  
)

export default component.exports